import { IIndexable } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ResolutionType } from './resolution_types_builder';

export class HoldType implements IIndexable {
  id: number;
  name: string;
  desc: string;
  is_registration_hold: boolean;
  send_notifications: boolean;
  publish_resolution_types: boolean;
  default_message: string;
  missing_type_msg: string;
  published_ts: string;
  resolution_types: Record<string, ResolutionType[]>;
  general_resolution?: Record<string, ResolutionType[]>;

  constructor(hold: HoldType) {
    _4.map(hold.resolution_types, (resolution: ResolutionType) => new ResolutionType(resolution));

    // TODO: create a resolution query that contains this logic
    const groups = _4.groupBy(hold.resolution_types, (res: ResolutionType) =>
      res.group ? res.group : this.defaultGroupName
    );

    hold.resolution_types = _4.omit(groups, this.defaultGroupName);
    hold.general_resolution = _4.pick(groups, this.defaultGroupName);

    _4.merge(this, hold);
  }

  static build(hold: HoldType): HoldType {
    return new HoldType(hold);
  }

  get defaultGroupName() {
    return 'General';
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-holds/src/builders/holdtype_builder.ts